import axios from "axios";

const googleMapsUrl = process.env.REACT_APP_GOOGLE_MAPS_URL;
const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

async function getLocationDetail(lat, lng) {
  return await axios.get(
    `${googleMapsUrl}?latlng=${lat},${lng}&key=${googleMapsApiKey}`
  );
}

async function getLocationPointsByCity(city) {
  return await axios.get(
    `${googleMapsUrl}?address=${city}&key=${googleMapsApiKey}`
  );
}
export const googleMapService = {
  getLocationDetail,
  getLocationPointsByCity
};
